import { useEffect, useState } from 'react'

// ── useOnlineStatus ──────────────────────────────────────────────────────
// Returns `true` when the browser thinks it's online and `false` when offline.
//
// Caveat: navigator.onLine is permissive — it can report `true` when the
// device is on a captive portal or a LAN with no real internet. A more
// reliable signal comes from actual fetch failures (classifyError handles
// that). Still, this hook is useful for showing an "offline" banner the
// instant the browser fires its `offline` event, before any request fails.
export default function useOnlineStatus() {
  const [online, setOnline] = useState(() =>
    typeof navigator !== 'undefined' && typeof navigator.onLine === 'boolean'
      ? navigator.onLine
      : true
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const goOnline = () => setOnline(true)
    const goOffline = () => setOnline(false)
    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)
    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  return online
}
